import { render, staticRenderFns } from "./VuesticWizard.vue?vue&type=template&id=0d24ce6d&scoped=true"
import script from "./VuesticWizard.vue?vue&type=script&lang=js"
export * from "./VuesticWizard.vue?vue&type=script&lang=js"
import style0 from "./VuesticWizard.vue?vue&type=style&index=0&id=0d24ce6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d24ce6d",
  null
  
)

export default component.exports